import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TopbannerPageRoutingModule } from './topbanner-routing.module';

import { TopbannerPage } from './topbanner.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TopbannerPageRoutingModule
  ],
  declarations: [TopbannerPage],
  exports: [TopbannerPage]
})
export class TopbannerPageModule {}
